/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TokenRequestQuery model module.
 * @module model/TokenRequestQuery
 * @version 0.0.1
 */
class TokenRequestQuery {
    /**
     * Constructs a new <code>TokenRequestQuery</code>.
     * @alias module:model/TokenRequestQuery
     */
    constructor() { 
        
        TokenRequestQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>TokenRequestQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TokenRequestQuery} obj Optional instance to populate.
     * @return {module:model/TokenRequestQuery} The populated <code>TokenRequestQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TokenRequestQuery();

            if (data.hasOwnProperty('activationcode')) {
                obj['activationcode'] = ApiClient.convertToType(data['activationcode'], 'String');
            }
            if (data.hasOwnProperty('expiry')) {
                obj['expiry'] = ApiClient.convertToType(data['expiry'], 'String');
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = ApiClient.convertToType(data['user'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TokenRequestQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TokenRequestQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['activationcode'] && !(typeof data['activationcode'] === 'string' || data['activationcode'] instanceof String)) {
            throw new Error("Expected the field `activationcode` to be a primitive type in the JSON string but got " + data['activationcode']);
        }
        // ensure the json data is a string
        if (data['expiry'] && !(typeof data['expiry'] === 'string' || data['expiry'] instanceof String)) {
            throw new Error("Expected the field `expiry` to be a primitive type in the JSON string but got " + data['expiry']);
        }
        // ensure the json data is a string
        if (data['user'] && !(typeof data['user'] === 'string' || data['user'] instanceof String)) {
            throw new Error("Expected the field `user` to be a primitive type in the JSON string but got " + data['user']);
        }

        return true;
    }


}



/**
 * @member {String} activationcode
 */
TokenRequestQuery.prototype['activationcode'] = undefined;

/**
 * @member {String} expiry
 */
TokenRequestQuery.prototype['expiry'] = undefined;

/**
 * @member {String} user
 */
TokenRequestQuery.prototype['user'] = undefined;






export default TokenRequestQuery;

